// oxlint-disable explicit-module-boundary-types, explicit-function-return-type

import type {
	GLOBAL_SETTINGS_QUERY_RESULT,
	PERSPECTIVE_QUERY_RESULT,
} from "@dfds-activity-map/cms/types";
import { QueryClient, queryOptions } from "@tanstack/solid-query";

import { api } from "./api";

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 0, refetchOnWindowFocus: "always", gcTime: 0 } },
});

const globalSettingsQueryOptions = () =>
	queryOptions({
		staleTime: 0,
		queryKey: ["globalSettings"],
		queryFn: async (): Promise<GLOBAL_SETTINGS_QUERY_RESULT> => {
			const { data, error } = await api.queries.public["global-settings"].get();
			if (error) {
				throw new Error(`Error fetching global settings`, { cause: error });
			}
			return data;
		},
	});

const perspectiveQueryOptions = (slug: string) =>
	queryOptions({
		staleTime: 0,
		queryKey: ["perspective", slug],
		queryFn: async (): Promise<PERSPECTIVE_QUERY_RESULT> => {
			const { data, error } = await api.queries.public.perspective({ slug }).get();
			if (error || !data) {
				throw new Error(`Error fetching perspective`, { cause: error });
			}
			return data;
		},
		retry: false,
	});

export { globalSettingsQueryOptions, perspectiveQueryOptions, queryClient };
